/**
 * @typedef TranslationListItem
 * @property {string} TranslationListItem.condition
 * @property {string} TranslationListItem.description
 * @property {number} TranslationListItem.id
 * @property {string} TranslationListItem.locale
 * @property {string} TranslationListItem.name
 */

const localeMatcher = {
  'ru-RU': 'ru',
  ru_RU: 'ru',
  'en-US': 'en',
  en_US: 'en',
  'kk-KZ': 'kk',
  kk_KZ: 'kk',
  'uk-UA': 'uk',
  uk_UA: 'uk',
  'es-MX': 'es',
  es_MX: 'es'
}

export default {
  methods: {
    /**
     * @param {any[] | TranslationListItem[]} translationList
     * @param {string} languageProp
     * @returns {any | TranslationListItem}
     */
    $_getTranslateFromArray (translationList, languageProp) {
      return translationList.find(t => {
        if (!languageProp) {
          return localeMatcher[t.locale] === this.$i18n.locale
        }

        return localeMatcher[t[languageProp]] === this.$i18n.locale
      })
    },

    /**
     * @param {object} translationList
     * @returns {string}
     */
    $_getTranslateFromObject (translationList) {
      for (const key of Object.keys(translationList)) {
        if (localeMatcher[key] === this.$i18n.locale) {
          return translationList[key]
        }
      }

      return translationList[this.$i18n.locale]
    },

    /**
     * @param {any[] | TranslationListItem[] | object} translationList
     * @param {string=} languageProp
     * @returns {string}
     */
    getTranslate (translationList, languageProp) {
      if (Array.isArray(translationList)) {
        return this.$_getTranslateFromArray(translationList, languageProp)
      }

      return this.$_getTranslateFromObject(translationList)
    }
  }
}
